import React from 'react';
import { motion } from 'framer-motion';
export function TechBackground() {
  return <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden" data-id="element-252">
      {/* Fixed Background Image */}
      <div className="absolute inset-0" data-id="element-253">
        <img src="https://images.unsplash.com/photo-1451187580459-43490279c0fa?q=80&w=2072&auto=format&fit=crop" alt="" className="w-full h-full object-cover" data-id="element-254" />
        <div className="absolute inset-0 bg-[#0B1426]/92" data-id="element-255" />
      </div>

      {/* Base Grid */}
      <div className="absolute inset-0 bg-grid-pattern opacity-[0.03]" data-id="element-256" />

      {/* Animated Gradient Orbs */}
      <motion.div animate={{
      scale: [1, 1.2, 1],
      opacity: [0.1, 0.15, 0.1]
    }} transition={{
      duration: 8,
      repeat: Infinity,
      ease: 'easeInOut'
    }} className="absolute -top-[30%] -right-[20%] w-[800px] h-[800px] rounded-full bg-[#d8a43e]/10 blur-[120px]" data-id="element-257" />
      <motion.div animate={{
      scale: [1, 1.3, 1],
      opacity: [0.08, 0.12, 0.08]
    }} transition={{
      duration: 10,
      repeat: Infinity,
      ease: 'easeInOut',
      delay: 2
    }} className="absolute -bottom-[30%] -left-[20%] w-[700px] h-[700px] rounded-full bg-blue-900/15 blur-[120px]" data-id="element-258" />
      <motion.div animate={{
      scale: [1, 1.1, 1],
      x: [0, 50, 0]
    }} transition={{
      duration: 12,
      repeat: Infinity,
      ease: 'easeInOut',
      delay: 4
    }} className="absolute top-[40%] right-[10%] w-[400px] h-[400px] rounded-full bg-purple-900/10 blur-[100px]" data-id="element-259" />

      {/* Floating Particles */}
      {[...Array(30)].map((_, i) => <motion.div key={`particle-${i}`} className="absolute rounded-full" style={{
      width: Math.random() * 3 + 1,
      height: Math.random() * 3 + 1,
      left: `${Math.random() * 100}%`,
      top: `${Math.random() * 100}%`,
      backgroundColor: i % 3 === 0 ? 'rgba(216, 164, 62, 0.4)' : 'rgba(255, 255, 255, 0.2)'
    }} animate={{
      y: [0, -150, 0],
      x: [0, Math.random() * 50 - 25, 0],
      opacity: [0, 0.8, 0]
    }} transition={{
      duration: Math.random() * 8 + 6,
      repeat: Infinity,
      ease: 'linear',
      delay: Math.random() * 8
    }} data-id="element-260" />)}

      {/* Horizontal Scan Lines */}
      <motion.div className="absolute left-0 right-0 h-[1px] bg-gradient-to-r from-transparent via-[#d8a43e]/20 to-transparent" animate={{
      top: ['-10%', '110%']
    }} transition={{
      duration: 8,
      repeat: Infinity,
      ease: 'linear'
    }} data-id="element-261" />
      <motion.div className="absolute left-0 right-0 h-[1px] bg-gradient-to-r from-transparent via-blue-500/10 to-transparent" animate={{
      top: ['110%', '-10%']
    }} transition={{
      duration: 12,
      repeat: Infinity,
      ease: 'linear',
      delay: 3
    }} data-id="element-262" />

      {/* Corner Circuit Decorations */}
      <svg className="absolute top-0 left-0 w-64 h-64 opacity-[0.05]" viewBox="0 0 200 200" data-id="element-263">
        <motion.path d="M0 50 L50 50 L50 100 L100 100" stroke="#d8a43e" strokeWidth="1" fill="none" initial={{
        pathLength: 0
      }} animate={{
        pathLength: 1
      }} transition={{
        duration: 2,
        repeat: Infinity,
        repeatType: 'reverse',
        ease: 'easeInOut'
      }} data-id="element-264" />
        <motion.circle cx="100" cy="100" r="3" fill="#d8a43e" animate={{
        opacity: [0.3, 1, 0.3]
      }} transition={{
        duration: 2,
        repeat: Infinity
      }} data-id="element-265" />
        <motion.path d="M0 100 L30 100 L30 150 L80 150" stroke="#d8a43e" strokeWidth="1" fill="none" initial={{
        pathLength: 0
      }} animate={{
        pathLength: 1
      }} transition={{
        duration: 3,
        repeat: Infinity,
        repeatType: 'reverse',
        ease: 'easeInOut',
        delay: 0.5
      }} data-id="element-266" />
      </svg>

      <svg className="absolute bottom-0 right-0 w-64 h-64 opacity-[0.05] rotate-180" viewBox="0 0 200 200" data-id="element-267">
        <motion.path d="M0 50 L50 50 L50 100 L100 100" stroke="#d8a43e" strokeWidth="1" fill="none" initial={{
        pathLength: 0
      }} animate={{
        pathLength: 1
      }} transition={{
        duration: 2,
        repeat: Infinity,
        repeatType: 'reverse',
        ease: 'easeInOut',
        delay: 1
      }} data-id="element-268" />
        <motion.circle cx="100" cy="100" r="3" fill="#d8a43e" animate={{
        opacity: [0.3, 1, 0.3]
      }} transition={{
        duration: 2,
        repeat: Infinity,
        delay: 1
      }} data-id="element-269" />
      </svg>

      {/* Data Stream Lines */}
      <div className="absolute top-0 bottom-0 left-[10%] w-[1px] overflow-hidden opacity-[0.03]" data-id="element-270">
        <motion.div className="w-full h-20 bg-gradient-to-b from-transparent via-[#d8a43e] to-transparent" animate={{
        y: ['-100%', '500%']
      }} transition={{
        duration: 4,
        repeat: Infinity,
        ease: 'linear'
      }} data-id="element-271" />
      </div>
      <div className="absolute top-0 bottom-0 right-[15%] w-[1px] overflow-hidden opacity-[0.03]" data-id="element-272">
        <motion.div className="w-full h-32 bg-gradient-to-b from-transparent via-blue-400 to-transparent" animate={{
        y: ['500%', '-100%']
      }} transition={{
        duration: 6,
        repeat: Infinity,
        ease: 'linear',
        delay: 2
      }} data-id="element-273" />
      </div>
      <div className="absolute top-0 bottom-0 left-[85%] w-[1px] overflow-hidden opacity-[0.02]" data-id="element-274">
        <motion.div className="w-full h-16 bg-gradient-to-b from-transparent via-[#d8a43e] to-transparent" animate={{
        y: ['-100%', '600%']
      }} transition={{
        duration: 5,
        repeat: Infinity,
        ease: 'linear',
        delay: 1
      }} data-id="element-275" />
      </div>

      {/* Noise Overlay */}
      <div className="absolute inset-0 opacity-[0.015] mix-blend-overlay" style={{
      backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)'/%3E%3C/svg%3E")`
    }} data-id="element-276" />
    </div>;
}